import { defineApiActionTypes } from 'store/common/action-helpers';
const prefix = 'graphql/GithubAuthButton';

export const LOGIN_WITH_GITHUB_CODE = defineApiActionTypes(`${prefix}/LOGIN_WITH_GITHUB_CODE`);



// WEBPACK FOOTER //
// ./src/store/graphql/GithubAuthButton/action-types.js